import React, { useState,useEffect } from 'react';
import Select, { components } from 'react-select';
import FullPageLoader from '../../common/FullPageLoader'
import * as HELPER from "../../config/helper";
import { ReceivedDate } from '../../component/DatePicker';
import { useParams } from "react-router-dom";
import ConfirmPopup from '../../common/ConfirmPopUp';
import { REMITTANCE_TYPE,ADMIN_OPS_STATUS,ADMIN_MAKER_STATUS,ADMIN_CHECKER_STATUS,LEAD_ASSIGN_TO,ADMIN_CHECKER_COMPLETE_STATUS,TRENCH_LIST } from '../../config/constant'
import { useLanguage } from "../../../src/context/LanguageContext";
import secureStorage from "../../config/encrypt";
import { saveRemittanceDetails, saveRemittancePayment } from '../../../src/store/slices/remittance';
import PaymentInfo from "./PaymentInfoCard";
import { toast } from "react-toastify";

interface PaymentData {
    amount: number | null;
}

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = (props: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(props.children, (child: any) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const getSelectedOption = (options: any[], value: any) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    return options.find((option: any) => String(option?.value) === String(value)) || null;
};

const roundAmount = (value: any) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? Math.round(numericValue) : 0;
};

const RemittancePaymentFormID = (props: any) => {
    const { remittanceDetails,remittance_status,paymentMadeFrom,isDisabled,ribbonData } = props
    const { id } = useParams<{ id: string,type:string }>()
    const { translations } = useLanguage();
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [formChangeDetect, setFormChangeDetect] = useState(false);
    const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
    const [isOpsLoggedIn, setIsOpsLoggedIn] = useState(false);
    const [isMakerLoggedIn, setIsMakerLoggedIn] = useState(false);
    const [isCheckerLoggedIn, setIsCheckerLoggedIn] = useState(false);
    const [roleStatus, setRoleStatus] = useState<any>([]);
    const [currentLoggedInUser, setCurrentLoggedInUser] = useState<number>(0);
    const [confirmationMessage, setConfirmationMessage] = useState<string>(translations.Remittance?.["SAVE_DETAIL_CONFIRMATION"]);
    const [confirmationFrom, setConfirmationFrom] = useState<string>("InsurerPartnerRemittance")
    const [leadRemark, setLeadRemark] = useState<string>("");
    const [LeadAssignTo, setLeadAssignTo] = useState<string>("");
    const [remittanceType, setRemittanceType] = useState<string>("");
    const [paymentData,setPaymentData] = useState<PaymentData>({amount: null});
    const [askForPayment, setAskForPayment] = useState<boolean>(false);
    const [form, setForm] = useState<any>({
        // Common
        payment_made_from: null,
        bank_transfer_fee: 0,
        agents_earning_payment_date: null,
        cashback: "",
        cashback_value: "",
        tax_cashback: "",
        net_cashback_disbursal: "",
        disbursement_fees:"",
        amount_to_disbursed:"",

        // Trench 1 – Points
        points: "",
        points_value: "",
        tax_points: "",
        net_point_disbursal: "",

        // Trench 2 – Commission
        commission: "",
        commission_value: "",
        tax_commission: "",
        net_commission_disbursal: "",
        // Trench 3 – Partner
        
        oto_to_partner: null,
        oto_commission_rate: "",
        basic_premium: "",
        ads_premium: "",
        gross_written_premium: "",
        discount_to_customer: "",
        net_premium: "",
        admin_fee: "",
        transation_fee: 0,
        total_invoice: "",
        net_off_commission: "",
        tax_oto_commission: "",
        total_commission: "",
        oto_need_to_partner: "",
        oto_points: "",
        tax_oto_points_vat: "",
        total_oto_points: "",
        partner_need_paid_oto: "",
        discount_to_oto: 0
    });
    const [errors, setErrors] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);
    // const [paymentMadeFrom,setPaymentMadeFrom] = useState<any[]>([]);
    const [trenchType,setTrenchType] = useState<number>(1);
    const isOpsEditableDisabled =
        isDisabled || !(isOpsLoggedIn || (isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetails?.remittance_status)));

    useEffect(() => {
        if (!remittanceDetails) return;

        setForm({
            payment_made_from: remittanceDetails.payment_from ?? null,

            // Trench 3 – Points
            points: remittanceDetails.points ?? "",
            points_value: remittanceDetails.points_value ?? "",
            tax_points: remittanceDetails.tax_points ?? "",
            net_point_disbursal: remittanceDetails.net_point_disbursal ?? "",

            // Trench 2 – Commission
            commission: remittanceDetails.commission_per ?? "",
            commission_value: remittanceDetails.commission_value ?? "",
            tax_commission: remittanceDetails.tax_commission ?? "",
            net_commission_disbursal: remittanceDetails.net_commission_disbursal ?? "",

            // Cashback (common)
            cashback: remittanceDetails.cashback ?? "",
            cashback_value: remittanceDetails.cashback_value ?? "",
            tax_cashback: remittanceDetails.tax_cashback ?? "",
            net_cashback_disbursal: remittanceDetails.net_cashback_disbursal ?? "",
            disbursement_fees:remittanceDetails.disbursement_fees ?? "",
            amount_to_disbursed:
                remittanceDetails.amount_to_disbursed === null ||
                remittanceDetails.amount_to_disbursed === undefined ||
                remittanceDetails.amount_to_disbursed === ""
                    ? ""
                    : roundAmount(remittanceDetails.amount_to_disbursed),

            // Trench 1 – Partner
            oto_to_partner: remittanceDetails.payment_from ?? null,
            oto_commission_rate: remittanceDetails.oto_commission_rate ?? "",
            basic_premium: remittanceDetails.basic_premium ?? "",
            ads_premium: remittanceDetails.ads_premium ?? "",
            gross_written_premium: remittanceDetails.gross_written_premium ?? "",
            discount_to_customer: remittanceDetails.discount_to_customer ?? "",
            net_premium: remittanceDetails.net_premium ?? "",
            admin_fee: remittanceDetails.admin_fee ?? "",
            total_invoice: remittanceDetails.total_invoice ?? "",
            net_off_commission: remittanceDetails.net_off_commission ?? "",
            tax_oto_commission: remittanceDetails.tax_oto_commission ?? "",
            total_commission: remittanceDetails.total_commission ?? "",
            oto_need_to_partner: remittanceDetails.oto_need_to_partner ?? "",
            oto_points: remittanceDetails.oto_points ?? "",
            tax_oto_points_vat: remittanceDetails.tax_oto_points ?? "",
            total_oto_points: remittanceDetails.total_oto_points ?? "",
            partner_need_paid_oto: remittanceDetails.partner_need_paid_to_oto ?? "",
            discount_to_oto:remittanceDetails.discount_to_oto ?? 0,
            // Editable only
            bank_transfer_fee: remittanceDetails.bank_transfer_fee ?? 0,
            agents_earning_payment_date: remittanceDetails.agent_earning_payment_date ?? null,
            transation_fee: remittanceDetails.transaction_fee ?? 0,
        });
        calculateAmount();

    }, [remittanceDetails]);

    useEffect(() => {
        const toNumber = (value: any) => Number(value) || 0;
        const values = {
            grossWrittenPremium: toNumber(form.gross_written_premium),
            adminFee: toNumber(form.admin_fee),
            disbursementFees: toNumber(form.disbursement_fees),
            netPointDisbursal: toNumber(form.net_point_disbursal),
            netCommissionDisbursal: toNumber(form.net_commission_disbursal),
            transactionFee: toNumber(form.transation_fee),
            bankTransferFee: toNumber(form.bank_transfer_fee),
            taxPoints: toNumber(form.tax_points),
        };

        const calculationMap: Record<number, number> = {
            [TRENCH_LIST['partner']]: values.grossWrittenPremium + values.adminFee + values.disbursementFees - values.transactionFee,
            [TRENCH_LIST['agency-points']]: values.netPointDisbursal + values.disbursementFees - values.bankTransferFee,
            [TRENCH_LIST['agency-commission']]:values.netCommissionDisbursal + values.disbursementFees - values.bankTransferFee,
        };
        const total = roundAmount(calculationMap[trenchType] ?? 0);
        setPaymentData({
            amount:total
        });
    }, [
        trenchType,form.gross_written_premium,form.admin_fee,form.disbursement_fees,form.net_point_disbursal,form.net_commission_disbursal,form.transation_fee,form.bank_transfer_fee,form.tax_points
    ]);

    useEffect(() => {
        setTrenchType(remittanceDetails?.remittance_type)
    }, [remittanceDetails]);

    const buildPayloadByTrench = () => {
        let payload: any = { lead_id: id };

        if (trenchType === 3) {
            payload = {
                ...payload,
                // payment_made_from: form.payment_made_from,
                // points: form.points,
                // points_value: form.points_value,
                // tax_points: form.tax_points,
                // net_point_disbursal: form.net_point_disbursal,
                bank_transfer_fee: form.bank_transfer_fee,
                agent_earning_payment_date: form.agents_earning_payment_date,
                // cashback: form.cashback,
                // cashback_value: form.cashback_value,
                // tax_cashback: form.tax_cashback,
                // net_cashback_disbursal: form.net_cashback_disbursal,
                type: remittanceDetails?.remittance_type_name,
                amount_to_disbursed:form.amount_to_disbursed,
                 ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetails?.remittance_status)) && { mark_payment_complete: true }),
                ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetails?.remittance_status)) && { remarks: leadRemark })
            };
        }

        if (trenchType === 2) {
            payload = {
                ...payload,
                // payment_made_from: form.payment_made_from,
                // commission: form.commission,
                // commission_value: form.commission_value,
                // tax_commission: form.tax_commission,
                // net_commission_disbursal: form.net_commission_disbursal,
                bank_transfer_fee: form.bank_transfer_fee,
                agent_earning_payment_date: form.agents_earning_payment_date,
                // cashback: form.cashback,
                // cashback_value: form.cashback_value,
                // tax_cashback: form.tax_cashback,
                // net_cashback_disbursal: form.net_cashback_disbursal,
                type: remittanceDetails?.remittance_type_name,
                amount_to_disbursed:form.amount_to_disbursed,
                ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetails?.remittance_status)) && { mark_payment_complete: true }),
                ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetails?.remittance_status)) && { remarks: leadRemark })
            };
        }

        if (trenchType === 1) {
                payload = {
                ...payload,
                // oto_to_partner: form.oto_to_partner,
                // oto_commission_rate: form.oto_commission_rate,
                // basic_premium: form.basic_premium,
                // ads_premium: form.ads_premium,
                // gross_written_premium: form.gross_written_premium,
                // discount_to_customer: form.discount_to_customer,
                // net_premium: form.net_premium,
                // admin_fee: form.admin_fee,
                transaction_fee: Number(form.transation_fee || 0),
                // total_invoice: form.total_invoice,
                // net_off_commission: form.net_off_commission,
                // tax_oto_commission: form.tax_oto_commission,
                // total_commission: form.total_commission,
                // oto_need_to_partner: form.oto_need_to_partner,
                // oto_points: form.oto_points,
                // tax_oto_points_vat: form.tax_oto_points_vat,
                // total_oto_points: form.total_oto_points,
                // partner_need_paid_oto: form.partner_need_paid_oto,
                discount_to_oto:form.discount_to_oto,
                amount_to_disbursed:form.amount_to_disbursed,
                type: remittanceDetails?.remittance_type_name,
                ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetails?.remittance_status)) && { mark_payment_complete: true }),
                ...((props.isCheckerLoggedIn || ADMIN_CHECKER_STATUS.includes(remittanceDetails?.remittance_status)) && { remarks: leadRemark })
            };
        }

        return payload;
    };

    const handleSubmit = async () => {
        try{
            setShowConfirmation(false);
            if (!validate()) {
                return;
            }
            setLoading(true);
            const payload = buildPayloadByTrench();
            const response:any = await saveRemittanceDetails(payload);
            if (response?.status === 200) {
                checkIfOpsIsLoggedIn();
                setFormChangeDetect(false);
                props.setCallReloadApi(props.callReloadApi+1);
                setShowConfirmation(false);
            }
        }catch (error) {
            console.error("Error while updating EMI detail:", error);
        }finally {
            setLoading(false);
        }
    }

    const validate = () => {
        const newErrors: any = {};
        let requiredFields: string[] = [];
          if (trenchType === TRENCH_LIST['agency-points']) {
            requiredFields = [
                // "payment_made_from",
                // "points",
                // "points_value",
                // "tax_points",
                // "net_point_disbursal",
                "bank_transfer_fee",
                "agents_earning_payment_date",
                // "cashback",
                // "cashback_value",
                // "tax_cashback",
                // "net_cashback_disbursal"
            ];
        }

        if (trenchType === TRENCH_LIST['agency-commission']) {
            requiredFields = [
                // "payment_made_from",
                // "commission",
                // "commission_value",
                // "tax_commission",
                // "net_commission_disbursal",
                "bank_transfer_fee",
                "agents_earning_payment_date",
                // "cashback",
                // "cashback_value",
                // "tax_cashback",
                // "net_cashback_disbursal"
            ];
        }

        if (trenchType === TRENCH_LIST['partner']) {
            requiredFields = [
                // "oto_to_partner",
                // "oto_commission_rate",
                // "basic_premium",
                // "ads_premium",
                // "gross_written_premium",
                // "discount_to_customer",
                // "net_premium",
                // "admin_fee",
                "transation_fee",
                // "total_invoice",
                // "net_off_commission",
                // "tax_oto_commission",
                // "total_commission",
                // "oto_need_to_partner",
                // "oto_points",
                // "tax_oto_points_vat",
                // "total_oto_points",
                // "partner_need_paid_oto",
                "discount_to_oto"
            ];
        }
        requiredFields.forEach((key) => {
            if (form[key] === null || form[key] === undefined || form[key] === "") {
                newErrors[key] = "This field is required";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validatePayment = async () => {
        if (!validate()) return;
        setShowConfirmation(true);
    }
    
    const handleFieldChange = (field: string, value: any) => {
        setForm((prev: any) => ({ ...prev, [field]: value }));
        setErrors((prev: any) => ({ ...prev, [field]: "" }));
        setFormChangeDetect(true);
    };

    // const getMasterConfigApi = () => {
    //     setLoading(true);
    //     dispatch(getMasterConfig())
    //     .then((res: any) => {
    //         if (res && res.status === 200) {
    //             if (res.data) {
    //                 setPaymentMadeFrom(res?.data?.payment_made_from)
    //             }
    //         }
    //     })
    //     .catch((err: Error) => {
    //         console.error("Error fetching master config:", err);
    //     })
    //     .finally(() => {
    //         setLoading(false);
    //     });
    // };
    
    // useEffect(() => {
    //     if (id) {
    //         getMasterConfigApi();
    //     }
    //     // eslint-disable-next-line
    // }, [id]);

    const sendToMaker = async () => {
        if(isMakerLoggedIn || (isAdminLoggedIn && ADMIN_MAKER_STATUS.includes(remittanceDetails?.remittance_status))){
            setConfirmationMessage(translations.Remittance?.["SEND_TO_OPS_CONFIRMATION"]);
            setConfirmationFrom("SendToMaker");
            setLeadAssignTo(LEAD_ASSIGN_TO['REM_OPS']);
            setShowConfirmation(true);
        }else if(isCheckerLoggedIn || (isAdminLoggedIn && ADMIN_CHECKER_STATUS.includes(remittanceDetails?.remittance_status))){
            setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"]);
            setConfirmationFrom("SendToMaker");
            setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
            setShowConfirmation(true);
        }else{
            if(isOpsLoggedIn || (isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetails?.remittance_status))){
                if(formChangeDetect){
                    const isFormValid = validate();
                    if(isFormValid){
                        setErrors({});
                        setConfirmationMessage(translations.Remittance?.["SAVE_DETAIL_CONFIRMATION"]);
                        setConfirmationFrom("SaveDetail");
                        setLeadAssignTo("");
                        setShowConfirmation(true);
                    }
                    
                }else{
                    const isFormValid = validate();
                    if(isFormValid){
                        setConfirmationMessage(translations.Remittance?.["SEND_TO_MAKER_CONFIRMATION"]);
                        setConfirmationFrom("SendToMaker");
                        setLeadAssignTo(LEAD_ASSIGN_TO['REM_FINANCE_MAKER']);
                        setShowConfirmation(true);
                    }
                }
            }
        }
    }

    const cancelFormChange = async () => {
        setErrors({});
        setFormChangeDetect(false);
        props.setCallReloadApi(props.callReloadApi+1);
    }

    const makePayment = async (remitance_type:string) => {
        const today = new Date();
        const policyStartDate = new Date(ribbonData?.policy_start_date);
        const creditTerms = Number(ribbonData?.credit_terms || 0);
        const allowedDate = new Date(policyStartDate);
        allowedDate.setDate(allowedDate.getDate() + creditTerms);
        if (today < allowedDate) {
            const messageTemplate = translations.Remittance?.["PAYMENT_MADE_FROM_BEFORE"];
            const message = messageTemplate?.replace("<<No. of Days>>", creditTerms);
            toast.error(message);
        }
        setRemittanceType(remitance_type);
        setAskForPayment(true);
    }

    const markPaymentComplete = async () => {
        setErrors({});
        setConfirmationMessage(translations.Remittance?.["COMPLETE_PAYMENT_CONFIRMATION"]);
        setConfirmationFrom("InsurerPartnerRemittance");
        setLeadAssignTo("");
        setShowConfirmation(true);
    }

     /**
   * Check if REM_OPS is logged In
   */
  const checkIfAdminIsLoggedIn = () => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
    if(roleName === "ADMIN" || roleName === "SALES_HEAD"){
      setIsAdminLoggedIn(true);
    }else{
      setIsAdminLoggedIn(false);
    }
  }

    /**
     * Check if REM_OPS is logged In
     */
    const checkIfOpsIsLoggedIn = () => {
        const authUserInfo = secureStorage.getItem("authUserInfo");
        const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
        if(roleName === "REM_OPS"){
        setIsOpsLoggedIn(true);
        }else{
        setIsOpsLoggedIn(false);
        }
    }

    /**
     * Check if Maker is logged In
     */
    const checkIfMakerIsLoggedIn = () => {
        const authUserInfo = secureStorage.getItem("authUserInfo");
        const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
        if(roleName === "REM_FINANCE_MAKER"){
        setIsMakerLoggedIn(true);
        }else{
        setIsMakerLoggedIn(false);
        }
    }

    /**
     * Check if Checker is logged In
     */
    const checkIfCheckerIsLoggedIn = () => {
        const authUserInfo = secureStorage.getItem("authUserInfo");
        const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
        if(roleName === "REM_FINANCE_CHECKER"){
        setIsCheckerLoggedIn(true);
        }else{
        setIsCheckerLoggedIn(false);
        }
    }

    useEffect(() => {
        const authUserInfo = secureStorage.getItem("authUserInfo");
        if(remittance_status.length > 0){
        const roleId = authUserInfo?.user_data?.assigned_role_ids;
        const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
        let filteredStatus: any[] = [];
        switch (roleName) {
            case "REM_OPS":
            case "REM_FINANCE_MAKER":
                filteredStatus = (remittance_status || []).filter((item: any) => item.role_id === roleId).map((item: any) => item.value);
                break;
            case "REM_FINANCE_CHECKER":
                // show only records matching user's role
                filteredStatus = (remittance_status || []).filter((item: any) => item.role_id === roleId && item.label === "Ready").map((item: any) => item.value);
                break;
            default:
                filteredStatus = [];
            break;
        }
        setRoleStatus(filteredStatus);
        }
        setCurrentLoggedInUser(+authUserInfo?.user_data?.user_id)
        checkIfAdminIsLoggedIn()
        checkIfOpsIsLoggedIn()
        checkIfMakerIsLoggedIn()
        checkIfCheckerIsLoggedIn()
     // eslint-disable-next-line
    },[remittance_status])


    const reloadDetail = async () => {
        props.setCallReloadApi(props.callReloadApi+1);
    }

    const calculateAmount = () => {
        const toNumber = (value: any) => Number(value) || 0;
        const values = {
            grossWrittenPremium: toNumber(form.gross_written_premium),
            adminFee: toNumber(form.admin_fee),
            disbursementFees: toNumber(form.disbursement_fees),
            netPointDisbursal: toNumber(form.net_point_disbursal),
            netCommissionDisbursal: toNumber(form.net_commission_disbursal),
            transactionFee: toNumber(form.transation_fee),
            bankTransferFee: toNumber(form.bank_transfer_fee),
            taxPoints: toNumber(form.tax_points),
        };

        const calculationMap: Record<number, number> = {
            [TRENCH_LIST['partner']]: values.grossWrittenPremium + values.adminFee + values.disbursementFees - values.transactionFee,
            [TRENCH_LIST['agency-points']]: values.netPointDisbursal + values.disbursementFees - values.bankTransferFee,
            [TRENCH_LIST['agency-commission']]:values.netCommissionDisbursal + values.disbursementFees - values.bankTransferFee,
        };
        const total = roundAmount(calculationMap[trenchType] ?? 0);
        setForm((prev: any) => prev.amount_to_disbursed === total ? prev : { ...prev, amount_to_disbursed: total });

    }

   useEffect(() => {
        calculateAmount();
    }, [
        trenchType,form.gross_written_premium,form.admin_fee,form.disbursement_fees,form.net_point_disbursal,form.net_commission_disbursal,form.transation_fee,form.bank_transfer_fee,form.tax_points
    ]);

    const confirmPaymentUpdate = async () => {
        try {
            setLoading(true);
            const data = new FormData();
            const selectedRemittanceType = remittanceType || remittanceDetails?.remittance_type_name;
            if (id) {
                data.append("lead_id", id);
            }
            if (selectedRemittanceType) {
                data.append("remittance_type", selectedRemittanceType);
            }
            const response:any = await saveRemittancePayment(data);
            if (response?.status === 200) {
                setAskForPayment(false);
                reloadDetail();
            }
        } catch (error) {
            console.error("Error while save Remittance Payment:", error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <FullPageLoader show={loading} />
            <div className="lead-detail-tabs">
                <div className="detail-form-sec">
                    <div className="route-files">
                        <div className="remittance-card">
                            {
                                isDisabled &&
                                <div className="card-dissable"></div>
                            }
                            <div className="lead-form-heading remittance-detail-title">
                                {
                                   trenchType === TRENCH_LIST['partner'] ?
                                        <h2>Insurance Partner Payment</h2> 
                                    :
                                        <h2>Incentive Payment - { trenchType === TRENCH_LIST['agency-points'] ? remittanceDetails?.remittance_type_slug : trenchType === TRENCH_LIST['agency-commission'] ? remittanceDetails?.remittance_type_slug : ''}</h2>
                                }
                            </div>
                            <div className="row">
                                {
                                    trenchType === TRENCH_LIST['agency-points'] &&
                                    <>
                                        <fieldset className="single-select col-md-3">
                                            <div className="material">
                                                <Select
                                                    components={{ ValueContainer: CustomValueContainer }}
                                                    options={paymentMadeFrom}
                                                    placeholder="Payment Made From"
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    value={getSelectedOption(paymentMadeFrom, form.payment_made_from)}
                                                    onChange={(option) => handleFieldChange("payment_made_from", option?.value)}
                                                    isDisabled={true}
                                                />
                                                {errors?.payment_made_from && (
                                                    <span className="error">{errors?.payment_made_from}</span>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="points" className="form-input" value={form.points ? `${form.points}%` : ""} 
                                                onChange={(e) => {
                                                    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                                                    handleFieldChange("points", rawValue);
                                                }} disabled/>
                                                <label data-label="Points (%)" className="form-label"></label>
                                                {(errors?.points) && (
                                                    <div className="error text-danger mb-2">
                                                        {errors?.points && <div>{errors?.points}</div>}
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="points_value" className="form-input" value={ HELPER.addCurrencyFormatting(form.points_value) } onChange={(e)=>handleFieldChange("points_value",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Points Value" className="form-label"></label>
                                                {errors?.points_value && <div className="error text-danger mb-2"><div>{errors.points_value}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="tax_points" className="form-input" value={ HELPER.addCurrencyFormatting(form.tax_points) } onChange={(e)=>handleFieldChange("tax_points",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Tax Points" className="form-label"></label>
                                                {errors?.tax_points && <div className="error text-danger mb-2"><div>{errors.tax_points}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="net_point_disbursal" className="form-input" value={ HELPER.addCurrencyFormatting(form.net_point_disbursal) } 
                                                onChange={(e) => {
                                                    const rawValue = HELPER.removeCurrencyFormattingId(e.target.value);
                                                    handleFieldChange("net_point_disbursal", rawValue);
                                                }} disabled/>
                                                <label data-label="Net Points Disbursal" className="form-label"></label>
                                                {(errors?.net_point_disbursal) && (
                                                    <div className="error text-danger mb-2">
                                                        {errors?.net_point_disbursal && <div>{errors?.net_point_disbursal}</div>}
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>
                                    </>
                                }
                                {
                                    trenchType === TRENCH_LIST['agency-commission'] &&
                                    <>
                                        <fieldset className="single-select col-md-3">
                                            <div className="material">
                                                <Select
                                                    components={{ ValueContainer: CustomValueContainer }}
                                                    options={paymentMadeFrom}
                                                    placeholder="Payment Made From"
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    value={getSelectedOption(paymentMadeFrom, form.payment_made_from)}
                                                    onChange={(option) => handleFieldChange("payment_made_from", option?.value)}
                                                    isDisabled={true}
                                                />
                                                {errors?.payment_made_from && (
                                                    <span className="error">{errors?.payment_made_from}</span>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="commission" className="form-input" value={form.commission ? `${form.commission}%` : ""} 
                                                onChange={(e) => {
                                                    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                                                    handleFieldChange("commission", rawValue);
                                                }} disabled/>
                                                <label data-label="Commission (%)" className="form-label"></label>
                                                {(errors?.commission) && (
                                                    <div className="error text-danger mb-2">
                                                        {errors?.commission && <div>{errors?.commission}</div>}
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="commission_value" className="form-input" value={ HELPER.addCurrencyFormatting(form.commission_value) } onChange={(e)=>handleFieldChange("commission_value",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Commission Value" className="form-label"></label>
                                                {errors?.commission_value && <div className="error text-danger mb-2"><div>{errors.commission_value}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="tax_commission" className="form-input" value={ HELPER.addCurrencyFormatting(form.tax_commission) } onChange={(e)=>handleFieldChange("tax_commission",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Tax Commission" className="form-label"></label>
                                                {errors?.tax_commission && <div className="error text-danger mb-2"><div>{errors.tax_commission}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="net_commission_disbursal" className="form-input" value={ HELPER.addCurrencyFormatting(form.net_commission_disbursal) } onChange={(e)=>handleFieldChange("net_commission_disbursal",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Net Commission Disbursal" className="form-label"></label>
                                                {errors?.net_commission_disbursal && <div className="error text-danger mb-2"><div>{errors.net_commission_disbursal}</div></div>}
                                            </div>
                                        </fieldset>
                                    </>
                                }
                                {
                                    (trenchType === TRENCH_LIST['agency-points'] || trenchType === TRENCH_LIST['agency-commission']) &&
                                    <>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="bank_transfer_fee" className="form-input" value={HELPER.addCurrencyFormatting(form.bank_transfer_fee) } 
                                                onChange={(e) => {
                                                    let rawValue:any = HELPER.removeCurrencyFormattingId(e.target.value);
                                                    handleFieldChange("bank_transfer_fee", rawValue);
                                                }} disabled={isOpsEditableDisabled}/>
                                                <label data-label="Bank Transfer Fee" className="form-label"></label>
                                                {errors?.bank_transfer_fee && <div className="error text-danger mb-2"><div>{errors.bank_transfer_fee}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3 receiveDateShow">
                                            <div className="material">
                                                
                                                <ReceivedDate
                                                    placeholder="Agent's Earnings Payment"
                                                    selectedDate={form.agents_earning_payment_date ? new Date(form.agents_earning_payment_date) : null}
                                                    onDateChange={(date:any) => handleFieldChange("agents_earning_payment_date", date?.toISOString())}
                                                    disabled={isOpsEditableDisabled}
                                                />
                                                {errors?.agents_earning_payment_date && (
                                                    <span className="error">{errors?.agents_earning_payment_date}</span>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="cashback" className="form-input" value={(form.cashback !== null && form.cashback !== undefined && form.cashback !== "") ? `${form.cashback}%` : ""} 
                                                onChange={(e) => {
                                                    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                                                    handleFieldChange("cashback", rawValue);
                                                }} disabled/>
                                                <label data-label="Cashback (%)" className="form-label"></label>
                                                {errors?.cashback && <div className="error text-danger mb-2"><div>{errors.cashback}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="cashback_value" className="form-input" value={ HELPER.addCurrencyFormatting(form.cashback_value) } onChange={(e)=>handleFieldChange("cashback_value",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                            <label data-label="Cashback Value" className="form-label"></label>
                                                {errors?.cashback_value && <div className="error text-danger mb-2"><div>{errors.cashback_value}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="tax_cashback" className="form-input" value={ HELPER.addCurrencyFormatting(form.tax_cashback) } onChange={(e)=>handleFieldChange("tax_cashback",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                            <label data-label="Tax Cashback" className="form-label"></label>
                                                {errors?.tax_cashback && <div className="error text-danger mb-2"><div>{errors.tax_cashback}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="net_cashback_disbursal" className="form-input" value={ HELPER.addCurrencyFormatting(form.net_cashback_disbursal) } onChange={(e)=>handleFieldChange("net_cashback_disbursal",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                            <label data-label="Net Cashback Disbursal" className="form-label"></label>
                                                {errors?.net_cashback_disbursal && <div className="error text-danger mb-2"><div>{errors.net_cashback_disbursal}</div></div>}
                                            </div>
                                        </fieldset>
                                    </> 
                                }
                                {
                                    trenchType === TRENCH_LIST['partner'] &&
                                    <>
                                        <fieldset className="single-select col-md-3">
                                            <div className="material">
                                                <Select
                                                    components={{ ValueContainer: CustomValueContainer }}
                                                    options={paymentMadeFrom}
                                                    placeholder="OTO to Partner"
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    value={getSelectedOption(paymentMadeFrom, form.oto_to_partner)}
                                                    onChange={(option) => handleFieldChange("oto_to_partner", option?.value)}
                                                    isDisabled={true}
                                                />
                                                {errors?.oto_to_partner && (
                                                    <span className="error">{errors?.oto_to_partner}</span>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="oto_commission_rate" className="form-input" value={form.oto_commission_rate ? `${form.oto_commission_rate}%` : ""} 
                                                onChange={(e) => {
                                                    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                                                    handleFieldChange("oto_commission_rate", rawValue);
                                                }} disabled/>
                                                <label data-label="OTO's Commission Rate" className="form-label"></label>
                                                {(errors?.oto_commission_rate) && (
                                                    <div className="error text-danger mb-2">
                                                        {errors?.oto_commission_rate && <div>{errors?.oto_commission_rate}</div>}
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="basic_premium" className="form-input" value={ HELPER.addCurrencyFormatting(form.basic_premium) } onChange={(e)=>handleFieldChange("basic_premium",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Basic Premium" className="form-label"></label>
                                                {errors?.basic_premium && <div className="error text-danger mb-2"><div>{errors.basic_premium}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="ads_premium" className="form-input" value={ HELPER.addCurrencyFormatting(form.ads_premium) } onChange={(e)=>handleFieldChange("ads_premium",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Addons Premium" className="form-label"></label>
                                                {errors?.ads_premium && <div className="error text-danger mb-2"><div>{errors.ads_premium}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="gross_written_premium" className="form-input" value={ HELPER.addCurrencyFormatting(form.gross_written_premium) } onChange={(e) => handleFieldChange("gross_written_premium", HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Gross Written Premium" className="form-label"></label>
                                                {(errors?.gross_written_premium) && (
                                                    <div className="error text-danger mb-2">
                                                        {errors?.gross_written_premium && <div>{errors?.gross_written_premium}</div>}
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="discount_to_customer" className="form-input" value={ HELPER.addCurrencyFormatting(form.discount_to_customer) } onChange={(e) => handleFieldChange("discount_to_customer", HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Discount To Customer" className="form-label"></label>
                                                {(errors?.discount_to_customer) && (
                                                    <div className="error text-danger mb-2">
                                                        {errors?.discount_to_customer && <div>{errors?.discount_to_customer}</div>}
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="net_premium" className="form-input" value={ HELPER.addCurrencyFormatting(form.net_premium) } onChange={(e) => handleFieldChange("net_premium", HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Net Premium" className="form-label"></label>
                                                {(errors?.net_premium) && (
                                                    <div className="error text-danger mb-2">
                                                        {errors?.net_premium && <div>{errors?.net_premium}</div>}
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="admin_fee" className="form-input" value={ HELPER.addCurrencyFormatting(form.admin_fee) } onChange={(e) => handleFieldChange("admin_fee", HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                                <label data-label="Admin Fee" className="form-label"></label>
                                                {(errors?.admin_fee) && (
                                                    <div className="error text-danger mb-2">
                                                        {errors?.admin_fee && <div>{errors?.admin_fee}</div>}
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="transation_fee" className="form-input" value={ HELPER.addCurrencyFormatting(form.transation_fee) } onChange={(e)=>{
                                                const rawValue = HELPER.removeCurrencyFormattingId(e.target.value);
                                                handleFieldChange("transation_fee", rawValue === "" ? 0 : rawValue);
                                            }} disabled={isOpsEditableDisabled}/>
                                            <label data-label="Transation Fee" className="form-label"></label>
                                                {errors?.transation_fee && <div className="error text-danger mb-2"><div>{errors.transation_fee}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                             <input spellCheck={false} type="text" placeholder=" " name="total_invoice" className="form-input" value={ HELPER.addCurrencyFormatting((+form.total_invoice || 0) + (+form.transation_fee || 0)) } onChange={(e)=>handleFieldChange("total_invoice",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                            <label data-label="Total Invoice" className="form-label"></label>
                                                {errors?.total_invoice && <div className="error text-danger mb-2"><div>{errors.total_invoice}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="net_off_commission" className="form-input" value={ HELPER.addCurrencyFormatting(form.net_off_commission) } onChange={(e)=>handleFieldChange("net_off_commission",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                            <label data-label="Net off Commission" className="form-label"></label>
                                                {errors?.net_off_commission && <div className="error text-danger mb-2"><div>{errors.net_off_commission}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="tax_oto_commission" className="form-input" value={ HELPER.addCurrencyFormatting(form.tax_oto_commission) } onChange={(e)=>handleFieldChange("tax_oto_commission",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                            <label data-label="Tax OTO's Commission (VAT)" className="form-label"></label>
                                                {errors?.tax_oto_commission && <div className="error text-danger mb-2"><div>{errors.tax_oto_commission}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="total_commission" className="form-input" value={ HELPER.addCurrencyFormatting(form.total_commission) } onChange={(e)=>handleFieldChange("total_commission",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                            <label data-label="Total Commission" className="form-label"></label>
                                                {errors?.total_commission && <div className="error text-danger mb-2"><div>{errors.total_commission}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="oto_need_to_partner" className="form-input" value={ HELPER.addCurrencyFormatting(form.oto_need_to_partner) } onChange={(e)=>handleFieldChange("oto_need_to_partner",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                            <label data-label="OTO Need's to Partners" className="form-label"></label>
                                                {errors?.oto_need_to_partner && <div className="error text-danger mb-2"><div>{errors.oto_need_to_partner}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="oto_points" className="form-input" value={(form.oto_points !== null && form.oto_points !== undefined && form.oto_points !== "") ? `Pts ${form.oto_points}` : ""} onChange={(e) => {
                                                const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                                                handleFieldChange("oto_points", rawValue);
                                            }} disabled/>
                                            <label data-label="OTO's Points" className="form-label"></label>
                                                {errors?.oto_points && <div className="error text-danger mb-2"><div>{errors.oto_points}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="tax_oto_points_vat" className="form-input" value={ HELPER.addCurrencyFormatting(form.tax_oto_points_vat) } onChange={(e)=>handleFieldChange("tax_oto_points_vat",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                            <label data-label="TAX OTO's Points (VAT)" className="form-label"></label>
                                                {errors?.tax_oto_points_vat && <div className="error text-danger mb-2"><div>{errors.tax_oto_points_vat}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="total_oto_points" className="form-input" value={(form.total_oto_points !== null && form.total_oto_points !== undefined && form.total_oto_points !== "") ? `Pts ${form.total_oto_points}` : ""} onChange={(e) => {
                                                const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                                                handleFieldChange("total_oto_points", rawValue);
                                            }} disabled/>
                                            <label data-label="Total OTO's Points" className="form-label"></label>
                                                {errors?.total_oto_points && <div className="error text-danger mb-2"><div>{errors.total_oto_points}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3"><div className="material">
                                            <input spellCheck={false} type="text" placeholder=" " name="partner_need_paid_oto" className="form-input" value={ HELPER.addCurrencyFormatting(form.partner_need_paid_oto) } onChange={(e)=>handleFieldChange("partner_need_paid_oto",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                            <label data-label="Partners Need Paid to OTO" className="form-label"></label>
                                                {errors?.partner_need_paid_oto && <div className="error text-danger mb-2"><div>{errors.partner_need_paid_oto}</div></div>}
                                            </div>
                                        </fieldset>
                                        <fieldset className="col-md-3">
                                            <div className="material">
                                                <input spellCheck={false} type="text" placeholder=" " name="discount_to_oto" className="form-input" value={form.discount_to_oto === null || form.discount_to_oto === undefined || form.discount_to_oto === "" ? "" : `${form.discount_to_oto}%`} 
                                                onChange={(e) => {
                                                    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                                                    handleFieldChange("discount_to_oto", rawValue);
                                                }} disabled={isOpsEditableDisabled}/>
                                                <label data-label="Discount to OTO" className="form-label"></label>
                                                {(errors?.discount_to_oto) && (
                                                    <div className="error text-danger mb-2">
                                                        {errors?.discount_to_oto && <div>{errors?.discount_to_oto}</div>}
                                                    </div>
                                                )}
                                            </div>
                                        </fieldset>
                                    </>
                                }
                                <fieldset className="col-md-3"><div className="material">
                                    <input spellCheck={false} type="text" placeholder=" " name="disbursement_fees" className="form-input" value={ HELPER.addCurrencyFormatting(form.disbursement_fees) } onChange={(e)=>handleFieldChange("disbursement_fees",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                    <label data-label="Xendit’s Disbursement Fee" className="form-label"></label>
                                        {errors?.disbursement_fees && <div className="error text-danger mb-2"><div>{errors.disbursement_fees}</div></div>}
                                    </div>
                                </fieldset>
                                <fieldset className="col-md-3"><div className="material">
                                    <input spellCheck={false} type="text" placeholder=" " name="amount_to_disbursed" className="form-input" value={ HELPER.addCurrencyFormatting(form.amount_to_disbursed) } onChange={(e)=>handleFieldChange("amount_to_disbursed",HELPER.removeCurrencyFormattingId(e.target.value))} disabled/>
                                    <label data-label="Amount to be Disbursed" className="form-label"></label>
                                        {errors?.amount_to_disbursed && <div className="error text-danger mb-2"><div>{errors.amount_to_disbursed}</div></div>}
                                    </div>
                                </fieldset>
                            </div>
                            {
                                ((remittanceDetails?.payment && isCheckerLoggedIn && +remittanceDetails?.checker_id === +currentLoggedInUser) || (remittanceDetails?.payment && isAdminLoggedIn && ADMIN_CHECKER_COMPLETE_STATUS.includes(remittanceDetails?.remittance_status))) &&
                                <PaymentInfo remittanceDetail={remittanceDetails}></PaymentInfo>
                            }
                            <div className="lead-form-filed">
                                {
                                    <>
                                        {
                                            isOpsLoggedIn && roleStatus?.includes(remittanceDetails?.remittance_status) && +remittanceDetails?.ops_id === +currentLoggedInUser &&
                                            <>
                                                <div className="btn-continue">
                                                    <button type="button" className="btn-primary" onClick={sendToMaker}>{translations.Remittance?.[!formChangeDetect ? "SEND_TO_MAKER" : "SAVE_DETAILS"] || translations.commonMsg?.loading}</button>
                                                    {formChangeDetect && (
                                                        <button type="button" className="btn-line" onClick={cancelFormChange}>Cancel</button>
                                                    )}
                                                </div>
                                            </>
                                        }
                                        {
                                            isMakerLoggedIn && roleStatus?.includes(remittanceDetails?.remittance_status) && +remittanceDetails?.maker_id === +currentLoggedInUser &&
                                            <>
                                                <div className="btn-continue">
                                                    <button type="button" className="btn-primary" onClick={sendToMaker}>{translations.Remittance?.["BACK_TO_OPS"] || translations.commonMsg?.loading}</button>
                                                    <button type="button" className="btn-line" onClick={() => makePayment(remittanceDetails.remittance_type_name)}>{translations.Remittance?.["INITIATE_PAYOUT"] || translations.commonMsg?.loading}</button>
                                                </div>
                                            </>
                                        }

                                        {
                                            isCheckerLoggedIn && roleStatus?.includes(remittanceDetails?.remittance_status) && +remittanceDetails?.checker_id === +currentLoggedInUser &&
                                            <>
                                                <div className="btn-continue">
                                                    {/* <button type="button" className="btn-primary" onClick={sendToMaker}>{translations.Remittance?.["BACK_TO_MAKER"] || translations.commonMsg?.loading}</button> */}
                                                    <button type="button" className="btn-line" onClick={markPaymentComplete}>{translations.Remittance?.["MARK_AS_COMPLETE"] || translations.commonMsg?.loading}</button>
                                                </div>
                                            </>

                                        }

                                    </>
                                }
                                {/* ============================== */}
                                {/* ADMIN-ONLY BUTTON CONDITIONS */}
                                {/* ============================== */}
                                {/* Admin sees OPS button when status is 1 or 2 */}
                                {
                                    isAdminLoggedIn && ADMIN_OPS_STATUS.includes(remittanceDetails?.remittance_status) && (
                                    <>
                                        <div className="btn-continue">
                                            <button type="button" className="btn-primary" onClick={sendToMaker}>{translations.Remittance?.[!formChangeDetect ? "SEND_TO_MAKER" : "SAVE_DETAILS"] || translations.commonMsg?.loading}</button>
                                            {formChangeDetect && (
                                                <button type="button" className="btn-line" onClick={cancelFormChange}>Cancel</button>
                                            )}
                                        </div>
                                    </>
                                    )
                                }
                                {/* Admin sees MAKER buttons when status is 3 or 4 */}
                                {
                                    isAdminLoggedIn && ADMIN_MAKER_STATUS.includes(remittanceDetails?.remittance_status) && (
                                    <>
                                        <div className="btn-continue">
                                            <button type="button" className="btn-primary" onClick={sendToMaker}>{translations.Remittance?.["BACK_TO_OPS"] || translations.commonMsg?.loading}</button>
                                            <button type="button" className="btn-line" onClick={() => makePayment(remittanceDetails.remittance_type_name)}>{translations.Remittance?.["INITIATE_PAYOUT"] || translations.commonMsg?.loading}</button>
                                        </div>
                                    </>
                                    )
                                }
                                {/* Admin sees CHECKER buttons when status is 5 */}
                                {
                                    isAdminLoggedIn && ADMIN_CHECKER_STATUS.includes(remittanceDetails?.remittance_status) && (
                                    <>
                                        <div className="btn-continue">
                                            {/* <button type="button" className="btn-primary" onClick={sendToMaker}>{translations.Remittance?.["BACK_TO_MAKER"] || translations.commonMsg?.loading}</button> */}
                                            <button type="button" className="btn-line" onClick={markPaymentComplete}>{translations.Remittance?.["MARK_AS_COMPLETE"] || translations.commonMsg?.loading}</button>
                                        </div>
                                    </>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                showConfirmation && 
                <ConfirmPopup
                    confirmNo={() => setShowConfirmation(false)}
                    confirmYes={handleSubmit}
                    message={confirmationMessage}
                    isConfirmNotVisible={true} 
                    from={confirmationFrom}
                    LeadAssignTo={LeadAssignTo}
                    remittanceType={remittanceDetails.remittance_type_name}
                    reloadDetail={reloadDetail}
                    setLeadRemark={setLeadRemark}>
                </ConfirmPopup>
            }
            {
                askForPayment && 
                <ConfirmPopup
                    confirmNo={() => setAskForPayment(false)}
                    confirmYes={confirmPaymentUpdate}
                    message={`Are you sure you want to proceed with the payment of ${HELPER.addCurrencyFormatting(paymentData.amount)} ? Once completed, this action cannot be undone.`}
                    title={'Confirm Payment'}
                    from={'CONFIRM_PAYMENT'}
                    isConfirmNotVisible={false}>
                </ConfirmPopup>
            }
        </>
    )
}

export default RemittancePaymentFormID;
